export default {
  title: 'Novo Ativos',
  title_edit: 'Editando Ativos',
  bulkRegister: 'Cadastro em massa',
  name: 'Nome*',
  placeType: 'Tipo de Local',
  place: 'Local',
  type: 'Tipo'
}
